/* Vec2STL storefront patch: numpy skeleton (drops scikit-image) + updated core. Loaded after vec2stl-python.js. */
Object.assign(window.VEC2STL_PY, {
"skel_np.py": String.raw`import numpy as np
from scipy.ndimage import correlate
_LUT = np.array([0, 0, 0, 1, 0, 0, 1, 3, 0, 0, 3, 1, 1, 0, 1, 3, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 3, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 3, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 3, 0, 2, 0, 0, 0, 3, 1, 0, 0, 1, 3, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 1, 3, 0, 0, 1, 3, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 1, 0, 0, 0, 0, 2, 2, 0, 0, 2, 0, 0, 0], dtype=np.uint8)
assert len(_LUT) == 256
_K = np.array([[1, 2, 4], [128, 0, 8], [64, 32, 16]], dtype=np.int32)
_RM1 = (_LUT == 1) | (_LUT == 3)
_RM2 = (_LUT == 2) | (_LUT == 3)

def skeletonize(mask):
    sk = np.pad(np.asarray(mask, dtype=bool), 1).astype(np.int32)
    while True:
        removed = False
        for rm in (_RM1, _RM2):
            code = correlate(sk, _K, mode='constant', cval=0)
            kill = (sk == 1) & rm[code]
            if kill.any():
                sk[kill] = 0
                removed = True
        if not removed:
            return sk[1:-1, 1:-1].astype(bool)
`,
"configurator_core.py": String.raw`import json, math
import numpy as np
from PIL import Image as PILImage
import pipeline_web as pw
import skel_np
pw.skeletonize_mask = skel_np.skeletonize
MM_PER_IN = 25.4
LINE_WEIGHT_MM = 0.46
MIN_FEATURE_MM = 1.5 * 0.352778
FORCED_WEIGHT_MM = MIN_FEATURE_MM * 1.1
BRIM_MARGIN_MM = 2.5
BRIM_HEIGHT_MM = 0.5
DESIGN_HEIGHT_MM = 0.7
MAX_SIDE_IN = 9.5
MIN_SIDE_IN = 0.5
TIER_SIDES = [4.0 + i * (MAX_SIDE_IN - 4.0) / 8 for i in range(9)]
TIER_AREAS = [round(s * s, 2) for s in TIER_SIDES]
TIER_PRICES = [round(9.99 + 5 * i, 2) for i in range(9)]

def tier_for(area_in2):
    for i, a in enumerate(TIER_AREAS):
        if area_in2 <= a + 1e-09:
            return i
    return None

def load_bw(img_path, target_width_mm):
    src = PILImage.open(img_path)
    has_alpha = src.mode in ('RGBA', 'LA') or 'transparency' in src.info
    if has_alpha:
        rgba = np.array(src.convert('RGBA'))
        if rgba[:, :, 3].std() > 5 and rgba[:, :, :3].max() < 10:
            alpha = rgba[:, :, 3].astype(np.float64) / 255.0
            img = PILImage.fromarray((255.0 * (1 - alpha)).astype(np.uint8), mode='L')
        else:
            bg = PILImage.new('RGBA', src.size, (255, 255, 255, 255))
            img = PILImage.alpha_composite(bg, src.convert('RGBA')).convert('L')
    else:
        img = src.convert('L')
    arr = np.array(img)
    ys, xs = np.nonzero(arr < 128)
    if len(xs) == 0:
        raise ValueError('No artwork found -- the image looks blank. Use dark lines on a light background.')
    ink = float((arr < 128).mean())
    if ink > 0.45:
        raise ValueError('This looks like a solid/filled image, not line art. Upload dark LINES on a light background (outlines only), or contact us for a filled-design quote.')
    pad = 4
    img = img.crop((max(0, xs.min() - pad), max(0, ys.min() - pad), min(img.width, xs.max() + pad + 1), min(img.height, ys.max() + pad + 1)))
    if img.width < 300 and img.height < 300:
        raise ValueError('Image resolution is too low (artwork under 300 px). Upload a larger or sharper file.')
    cap = min(1600, max(800, int(target_width_mm / 0.05)))
    if img.width > cap:
        img = img.resize((cap, max(1, int(img.height * cap / img.width))), PILImage.LANCZOS)
    return img

def generate(img_path, overall_width_in, out_stl='/tmp/output.stl', progress=None):
    say = progress or (lambda pct, msg: None)
    if not MIN_SIDE_IN <= overall_width_in <= MAX_SIDE_IN:
        raise ValueError(f'Width must be between {MIN_SIDE_IN} and {MAX_SIDE_IN} inches.')
    design_w_mm = overall_width_in * MM_PER_IN - 2 * BRIM_MARGIN_MM
    if design_w_mm <= 2:
        raise ValueError('That width is too small for this design.')
    say(5, 'Loading image...')
    img = load_bw(img_path, design_w_mm)
    px_to_mm = design_w_mm / img.width
    mask = np.array(img) < 128
    say(20, 'Tracing lines...')
    junctions = []
    strokes = pw.skeletonize_lineart_web(mask, FORCED_WEIGHT_MM, px_to_mm, min_feature_mm=FORCED_WEIGHT_MM, junctions_out=junctions)
    strokes = strokes.simplify(0.0, preserve_topology=True)
    say(50, 'Smoothing junctions...')
    half_w = FORCED_WEIGHT_MM / px_to_mm / 2.0
    strokes = pw.fillet_junctions(strokes, half_w * 0.5, junction_points=junctions)
    strokes = strokes.buffer(0)
    strokes = pw.drop_degenerate_vertices(strokes)
    say(70, 'Building base plate...')
    brim_poly, design_poly = pw.add_brim(strokes, BRIM_MARGIN_MM / px_to_mm)
    minx, miny, maxx, maxy = brim_poly.bounds
    w_in = (maxx - minx) * px_to_mm / MM_PER_IN
    h_in = (maxy - miny) * px_to_mm / MM_PER_IN
    if max(w_in, h_in) > MAX_SIDE_IN + 0.03:
        raise ValueError(f'At this width the stamp would be {w_in:.2f}" x {h_in:.2f}". Max is {MAX_SIDE_IN}" on either side -- reduce the width.')
    w_in, h_in = (min(w_in, MAX_SIDE_IN), min(h_in, MAX_SIDE_IN))
    area = w_in * h_in
    tier = tier_for(area)
    say(82, 'Building 3D model...')
    tris = pw.build_stamp_triangles_cdt(brim_poly, design_poly, BRIM_HEIGHT_MM, DESIGN_HEIGHT_MM, px_to_mm)
    pw.write_binary_stl(tris, out_stl)
    return {'width_in': round(w_in, 2), 'height_in': round(h_in, 2), 'area_in2': round(area, 1), 'tier': tier, 'tier_index': tier, 'price': TIER_PRICES[tier], 'tier_max_area': TIER_AREAS[tier], 'n_triangles': len(tris), 'line_weight_mm': round(FORCED_WEIGHT_MM, 3)}
`
});
